import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  @ViewChild('inputMultiline') inputMultiline: ElementRef<HTMLTextAreaElement>;
  
  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter();
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() labelOptional: string = '';
  @Input() errorHint: string = '';
  @Input() type: string = 'text';

  @Input() showError: boolean = true;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() invalid: boolean = false;
  @Output() invalidChange: EventEmitter<boolean> = new EventEmitter();
  @HostBinding('attr.size')
  @Input() size: InputSize = InputSize.MEDIUM;
  @Input() mode: InputType = InputType.SINGLE;
  @Input() disableButtonFocus: boolean = false;

  @Output() onInput: EventEmitter<string> = new EventEmitter();
  @Output() onFocus: EventEmitter<void> = new EventEmitter();
  @Output() onBlur: EventEmitter<void> = new EventEmitter();
  
  @Input() inputGroup: FormGroup;
  @Input() fieldName: string = 'inputData';

  @Input() buttonIcon: string = '';
  @Output() buttonClick: EventEmitter<void> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
  ) { }

  public ngOnInit(): void {
    if (!this.inputGroup) {
      this.inputGroup = this.fb.group({
        inputData: [this.value],
      });
    }
  }

  public inputHandler() {
    this.value = this.inputGroup.controls[this.fieldName].value.trim();
    this.valueChange.emit(this.value);
    this.onInput.emit(this.value);

    this.invalidChange.emit(!this.inputGroup.controls[this.fieldName].valid);
  }

  public onButtonClick(event: PointerEvent) {
    if (this.disableButtonFocus && !event.pointerType) return;
    this.buttonClick.emit();
  }

  public focus() {
    setTimeout(() => {
      if (this.input?.nativeElement) {
        this.input.nativeElement.focus();
      } else if (this.inputMultiline?.nativeElement) {
        this.inputMultiline.nativeElement.focus();
      }
    }, 0);
  }
}

export enum InputSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum InputType {
  SINGLE = 'single',
  MULTILINE = 'multiline',
}